import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import CardExpand from '@/views/components/CardExpand.vue';
import { mdiEye } from '@mdi/js';
import { ILegisnormas } from '../../types';
import { ConsultaLegislacaoStore } from '@/views/legislacao/store/ConsultaLegislacaoStore';
import IconPaginaSimplificada from '@/views/components/icons/IconPaginaSimplificada.vue';
import IconPaginaDetalhada from '@/views/components/icons/IconPaginaDetalhada.vue';
import IconTextoNorma from '@/views/components/icons/IconTextoNorma.vue';
import SeletorOpcoesImpressão from '@/views/components/SeletorOpcoesImpressão.vue';

interface IProps {
  legisnormas?: ILegisnormas;
  isSelecionado: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardResultado',
  props: {
    legisnormas: null,
    isSelecionado: { type: Boolean }
  },
  emits: ['toggle-check'],
  setup(__props: any) {

const props = __props as {
  legisnormas?: ILegisnormas;
  isSelecionado: boolean;
};

const store = ConsultaLegislacaoStore();




const highlightedDesc = computed(
  () => props.legisnormas?.highlightedDesc || ''
);

const itensImpressao = [
  {
    text: 'Simplificado',
    value: 'S',
    icone: IconPaginaSimplificada,
  },
  {
    text: 'Detalhado',
    value: 'D',
    icone: IconPaginaDetalhada,
  },
  {
    text: 'Texto da norma',
    value: 'T',
    icone: IconTextoNorma,
  },
];

const abrirLegislacao = (cdLegislacao?: number) => {
  window.open(`./find/${cdLegislacao}`);
};

return { __sfc: true,store, props, highlightedDesc, itensImpressao, abrirLegislacao, CardExpand, mdiEye, SeletorOpcoesImpressão }
}

})